/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/ban-ts-comment */
//@ts-ignore
(async function () {
  const envValues = await fetch(`${process.env.PUBLIC_URL}/appsettings.txt`);
  //@ts-ignore
  window.env = await envValues.json();
  await import("./appRoot");
})();
